import { useTranslation } from 'react-i18next';
import {
  ServiceProviderWarningMessageWrapper,
  ServiceProviderWarningStores,
} from './ServiceProviderWarningMessage.styles';
import AppleStoreBadge from '@/assets/images/social/apple_store_badge.svg?react';
import GoogleStoreBadge from '@/assets/images/social/google_store_badge.png';

const ServiceProviderWarningMessage = () => {
  const { t } = useTranslation();

  return (
    <ServiceProviderWarningMessageWrapper>
      <p className="text-danger">
        {t('pageLogin.theServiceProviderPortalIsAvailable')}
      </p>
      <p className="text-danger">{t('pageLogin.downloadApp')}</p>
      <ServiceProviderWarningStores>
        <a
          data-testid="apple-store-link"
          href={t('pageLogin.downloadAppLink.apple')}
          target="_blank"
          rel="noreferrer"
        >
          <AppleStoreBadge />
        </a>
        <a
          data-testid="google-store-link"
          href={t('pageLogin.downloadAppLink.google')}
          target="_blank"
          rel="noreferrer"
        >
          <img src={GoogleStoreBadge} alt="Google Play Store" />
        </a>
      </ServiceProviderWarningStores>
    </ServiceProviderWarningMessageWrapper>
  );
};

export default ServiceProviderWarningMessage;
